module.exports = __webpack_public_path__ + "static/media/database-integrations.01c28345.jpg";